import React from 'react';

const ConfirmDialog = ({ message, onConfirm, onCancel, type = 'warning' }) => {
  const styles = {
    warning: {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="48"
          height="48"
          fill="currentColor"
          viewBox="0 0 256 256"
          className="text-yellow-500"
        >
          <path d="M236.8,188.09,149.35,36.22h0a24.76,24.76,0,0,0-42.7,0L19.2,188.09a23.51,23.51,0,0,0,0,23.72A24.35,24.35,0,0,0,40.55,224h174.9a24.35,24.35,0,0,0,21.33-12.19A23.51,23.51,0,0,0,236.8,188.09ZM222.93,203.8a8.5,8.5,0,0,1-7.48,4.2H40.55a8.5,8.5,0,0,1-7.48-4.2,7.59,7.59,0,0,1,0-7.72L120.52,44.21a8.75,8.75,0,0,1,15,0l87.45,151.87A7.59,7.59,0,0,1,222.93,203.8ZM120,144V104a8,8,0,0,1,16,0v40a8,8,0,0,1-16,0Zm20,36a12,12,0,1,1-12-12A12,12,0,0,1,140,180Z"></path>
        </svg>
      ),
      confirmBtn: 'bg-yellow-600 hover:bg-yellow-700',
    },
    danger: {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="48"
          height="48"
          fill="currentColor"
          viewBox="0 0 256 256"
          className="text-red-500"
        >
          <path d="M165.66,101.66,139.31,128l26.35,26.34a8,8,0,0,1-11.32,11.32L128,139.31l-26.34,26.35a8,8,0,0,1-11.32-11.32L116.69,128,90.34,101.66a8,8,0,0,1,11.32-11.32L128,116.69l26.34-26.35a8,8,0,0,1,11.32,11.32ZM232,128A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z"></path>
        </svg>
      ),
      confirmBtn: 'bg-red-600 hover:bg-red-700',
    },
  };

  const style = styles[type] || styles.warning;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm animate-fade-in">
      <div className="bg-[#1a1d17] border-2 border-[#4a5f3a] rounded-lg shadow-2xl p-6 max-w-md w-full mx-4 animate-scale-in">
        <div className="flex flex-col items-center text-center">
          <div className="mb-4">{style.icon}</div>
          <h3 className="text-xl font-bold text-white mb-2">确认操作</h3>
          <p className="text-gray-300 mb-6 leading-relaxed">{message}</p>
          <div className="flex gap-3 w-full">
            <button
              onClick={onCancel}
              className="flex-1 px-4 py-2 bg-gray-600 hover:bg-gray-700 text-white rounded-lg transition-colors font-medium"
            >
              取消
            </button>
            <button
              onClick={onConfirm}
              className={`flex-1 px-4 py-2 ${style.confirmBtn} text-white rounded-lg transition-colors font-medium`}
            >
              确定
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
